/**
 * The Universities by state component
 */
function UniversitiesByStateComponent() {
  let universitiesList;
  let collegeSelector;
  let universityContinueButton;
  let stateSelector;
  let noUniversitiesMessage;

  /**
   * Initializes the universities by state component
   */
  const init = () => {
    collegeSelector = document.querySelector('#select__college');
    universityContinueButton = document.querySelector('.university__continue__button');
    noUniversitiesMessage = document.querySelector('#no-universities-message');
    parseUniversities();
    initStateSelector();
    initCollegeSelector();
  };

  /**
   * Hides the no universities message
   */
  const hideNoUniversitiesMessage = () => {
    noUniversitiesMessage.classList.add('hide');
    collegeSelector.classList.remove('hide');
  };

  /**
   * Shows the no universities message
   */
  const showNoUniversitiesMessage = () => {
    noUniversitiesMessage.classList.remove('hide');
    collegeSelector.classList.add('hide');
  };

  /**
   * Parses the universities list from the JSON string
   */
  const parseUniversities = () => {
    universitiesList = JSON.parse(document.getElementById('universities-list-json').innerHTML);
  };

  /**
   * Initializes the state selector
   */
  const initStateSelector = () => {
    stateSelector = document.querySelector('#college-state');
    stateSelector.appendChild(buildSelectAStateOption());
    stateSelector.addEventListener('change', (e) => setCollegeSelector(e.target.value));
  };

  /**
   * Initializes the college selector
   */
  const initCollegeSelector = () => {
    collegeSelector.innerHTML = '';
    collegeSelector.appendChild(buildSelectAStateOption());
    collegeSelector.disabled = true;
    collegeSelector.addEventListener('change', (e) => selectCollege(e.target.value));
    universityContinueButton.disabled = true;
  };

  /**
   * Builds the select a state option
   */
  const buildSelectAStateOption = () => {
    const option = document.createElement('option');
    option.innerHTML = 'Select a state';
    option.disabled = true;
    option.selected = true;

    return option;
  };

  /**
   * Sets the college selector based on the state
   *
   * @param {string} state The state to filter the colleges by
   */
  const setCollegeSelector = (state) => {
    const options = universitiesList.filter((university) => university.state === state);
    initCollegeSelector();
    if (options.length > 0) {
      updateCollegeSelectorPlaceHolderText('Select your college');
      setCollegeOptions(options);
      collegeSelector.disabled = false;
      hideNoUniversitiesMessage();
    } else {
      showNoUniversitiesMessage();
    }
  };

  /**
   * Updates the placeholder text for the college selector
   *
   * @param {string} placeHolderText The text to set as the placeholder
   */
  const updateCollegeSelectorPlaceHolderText = (placeHolderText) => {
    collegeSelector.firstChild.innerHTML = placeHolderText;
  };

  /**
   * Sets the options for the college selector
   *
   * @param {array} collegeOptions The list of colleges to set as options
   */
  const setCollegeOptions = (collegeOptions) => {
    collegeOptions.forEach((collegeOption) => {
      const option = document.createElement('option');
      option.value = collegeOption.id;
      option.innerHTML = collegeOption.name;
      collegeSelector.appendChild(option);
    });
  };

  /**
   * Selects a college and enables the continue button
   *
   * @param {string} collegeId The id of the college to select
   */
  const selectCollege = (collegeId) => {
    const college = universitiesList.find((university) => university.id == collegeId);
    if (college) {
      universityContinueButton.setAttribute('data-href', college.url);
      universityContinueButton.disabled = false;
    } else {
      universityContinueButton.disabled = true;
    }
  };

  $(init);
}

new UniversitiesByStateComponent();
